// filepath: /exdash-frontend/exdash-frontend/src/api/queries/auth.ts

import { useQuery } from '@tanstack/react-query'
import { AuthStatusResponse } from '../models/AuthStatusResponse'
import { AuthService } from '../services/AuthService'

/**
 * 認証状態を取得するためのクエリフック
 */
export function useAuthStatusQuery() {
  return useQuery<AuthStatusResponse, Error>({
    queryKey: ['authStatus'],
    queryFn: () => AuthService.status(),
    // エラーが発生した場合は未認証とみなす
    retry: false,
    // より頻繁に認証状態を再確認（3分間隔に短縮）
    refetchInterval: 3 * 60 * 1000,
    // バックグラウンドでの再フェッチを有効化
    refetchOnWindowFocus: true,
    // ネットワーク再接続時にも再フェッチ
    refetchOnReconnect: true,
  })
}
